import React from 'react';

import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';

export const getBrasilPhoneMask = (
  inputEvent: React.ChangeEvent<HTMLInputElement>,
): {
  phoneNumber: string;
  isPhoneNumberValid: boolean;
  phoneNumberErrorMessage: string;
  phoneNumberDidigts: number;
} => {
  let isPhoneNumberValid = false;
  let phoneNumberErrorMessage = '';
  const phoneNumberDidigts = 14; // max 15
  const { defaultValue, value } = inputEvent.target;
  const phoneRegex = /^[(]\d{2}[)]\s\d{4}[-]\d{4,5}$/;
  let phoneFormat = value.replace(/[a-zA-Z]/g, '');

  if (defaultValue.length < phoneFormat.length) {
    phoneFormat = phoneFormat.replace(
      /^(\d{2})(\d{4})(\d{4,5})$/,
      (_, p1, p2, p3) => `(${p1}) ${p2}-${p3}`,
    );
    if (defaultValue === '' && phoneFormat.length === 1) {
      phoneFormat = `(${phoneFormat}`;
    }
    if (phoneFormat.length === 3) {
      phoneFormat = `${phoneFormat}) `;
    }
    if (phoneFormat.length === 9) {
      phoneFormat = `${phoneFormat}-`;
    }
  }

  isPhoneNumberValid = phoneRegex.test(phoneFormat);

  if (phoneFormat.length > phoneNumberDidigts && !isPhoneNumberValid) {
    phoneNumberErrorMessage = I18N_STRINGS.INVALID_PHONE_NUMBER;
  }

  return {
    phoneNumber: phoneFormat,
    isPhoneNumberValid,
    phoneNumberErrorMessage,
    phoneNumberDidigts,
  };
};

export const ArgentinaPhoneMask = (
  inputEvent: React.ChangeEvent<HTMLInputElement>,
) => {
  const { defaultValue, value } = inputEvent.target;
  const phoneRegex = /^[(]\d{3}[)]\s\d{3}[-]\d{4}$/;
  let phoneFormat = value.replace(/[a-zA-Z]/g, '');
  let phoneNumberErrorMessage = '';
  const phoneNumberDidigts = 10;

  if (defaultValue.length < phoneFormat.length) {
    if (defaultValue === '') {
      phoneFormat = `(${phoneFormat}`;
    }
    if (phoneFormat.length === 4) {
      phoneFormat = `${phoneFormat}) `;
    }
    if (phoneFormat.length === 9) {
      phoneFormat = `${phoneFormat}-`;
    }
  }
  const isPhoneNumberValid = phoneRegex.test(phoneFormat);

  if (!isPhoneNumberValid) {
    phoneNumberErrorMessage = I18N_STRINGS.INVALID_PHONE_NUMBER;
  }

  return {
    phoneNumber: phoneFormat,
    isPhoneNumberValid,
    phoneNumberErrorMessage,
    phoneNumberDidigts,
  };
};

export const getPeruPhoneMask = (
  inputEvent: React.ChangeEvent<HTMLInputElement>,
) => {
  const { value } = inputEvent.target;

  const phoneNumber = value.replace(/[a-zA-Z]/g, '');

  return {
    phoneNumber,
    isPhoneNumberValid: !!(phoneNumber && phoneNumber.length > 8),
    phoneNumberErrorMessage: '',
    phoneNumberDidigts: 9,
  };
};
